import { useMutation } from '@apollo/client';

import LearnerObjectUpdateSkillsWanted from 'bundles/onboarding-common/queries/LearnerObjectUpdateSkillsWanted.graphql';
import type {
  LearnerObject_UpdateSkillsWantedV2Mutation as LearnerObjectUpdateSkillsWantedMutation,
  LearnerObject_UpdateSkillsWantedV2MutationVariables as LearnerObjectUpdateSkillsWantedMutationVariables,
} from 'bundles/onboarding-common/queries/__generated__/LearnerObjectUpdateSkillsWanted';
import type { Skill } from 'bundles/onboarding-common/types';
import { formatSkillsForLearnerObject } from 'bundles/onboarding-common/utils/userProfileUtils';

const useLearnerObjectUpdateSkillsWanted = () => {
  const [updateSkillsWantedMutation] = useMutation<
    LearnerObjectUpdateSkillsWantedMutation,
    LearnerObjectUpdateSkillsWantedMutationVariables
  >(LearnerObjectUpdateSkillsWanted, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
  });

  const updateSkillsWanted = async (skills: Array<Skill>) => {
    const formattedSkills = formatSkillsForLearnerObject(skills);

    const variables: LearnerObjectUpdateSkillsWantedMutationVariables = {
      input: {
        skillsWantedV2: formattedSkills,
      },
    };

    const { errors, data } = await updateSkillsWantedMutation({
      variables,
    });

    if (errors) {
      return { success: false, errors: errors.map((error) => error.message) };
    }

    if (data?.LearnerObject_UpdateSkillsWantedV2.__typename === 'LearnerObject_UpdateSkillsWantedV2ResultError') {
      return {
        success: false,
        errors: [data.LearnerObject_UpdateSkillsWantedV2.message],
      };
    }

    return { success: true, errors: [] };
  };

  return {
    updateSkillsWanted,
  };
};

export default useLearnerObjectUpdateSkillsWanted;
